import { render, staticRenderFns } from "./MotivoCancelamento.vue?vue&type=template&id=4b30a892"
import script from "./MotivoCancelamento.vue?vue&type=script&lang=js"
export * from "./MotivoCancelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports